import { useState, useRef, useEffect, useCallback } from 'react';
import { fetchBatchList } from '../services/generatorBatchApi';

/**
 * Storico recente dei batch dell'utente autenticato (`GET /generator-batch/batches`).
 * Ricaricabile su richiesta; annulla le richieste obsolete.
 */
export function useBatchHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);
  const [token, setToken] = useState(0);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setLoading(true);
    setError(null);
    fetchBatchList(controller.signal)
      .then((data) => setItems(Array.isArray(data?.items) ? data.items : []))
      .catch((err) => {
        if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') return;
        setError('Impossibile caricare lo storico dei batch.');
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [token]);

  const reload = useCallback(() => setToken((t) => t + 1), []);

  return { items, loading, error, reload };
}
